// Centralized async task user messages
// Update these messages to change user-facing text for async operations

const ASYNC_TASK_MESSAGES = {
  BOARD_DUPLICATION: {
    title: "Board Duplication Started",
    message: `
      Your board duplication request has started and is being processed in the background.<br/><br/>
      <b>What happens next?</b><br/>
      - You can continue working while we prepare your new board.<br/>
      - A notification banner will appear at the top of the screen.<br/>
      - When the duplication is complete, the banner will update and you can double-click it to open your new board.
    `
  },
  CSV_IMPORT: {
    title: "Import Started",
    message: `
      Your CSV import has started and is being processed in the background.<br/><br/>
      <b>What happens next?</b><br/>
      - You can continue working while we import your data.<br/>
      - A notification banner will appear at the top of the screen.<br/>
      - When the import is complete, the banner will update and you can double-click it to review the results.
    `
  },
  CSV_EXPORT: {
    title: "Export Started",
    message: `
      Your export request has started and is being processed in the background.<br/><br/>
      <b>What happens next?</b><br/>
      - You can continue working while we prepare your export.<br/>
      - A notification banner will appear at the top of the screen.<br/>
      - When the export is complete, the banner will update and you can double-click it to download your file. <br/>
      - When the export is complete, your file will be automatically downloaded.
    `
  },
  UNDO_CSV_IMPORT: {
    title: "Undo Import Started",
    message: `
      The undo import process has started and is being processed in the background.<br/><br/>
      <b>What happens next?</b><br/>
      - You can continue working while we revert your import.<br/>
      - A notification banner will appear at the top of the screen.<br/>
      - When the undo is complete, the banner will update and you can double-click it to review the results.
    `
  },
  DEMO_BOARD_CREATION: {
    title: "Test Drive Board Creation Started",
    message: `
      Your test drive board is being created in the background.<br/><br/>
      <b>What happens next?</b><br/>
      - You can continue working while we set up your test drive board.<br/>
      - A notification banner will appear at the top of the screen.<br/>
      - When the board is ready, the banner will update and you can double-click it to open your new board.
    `
  },
  BOARD_IMPORT: {
    title: "Board Import Started",
    message: `
      Your board import has started and is being processed in the background.<br/><br/>
      <b>What happens next?</b><br/>
      - You can continue working while we import your board.<br/>
      - A notification banner will appear at the top of the screen.<br/>
      - When the import is complete, the banner will update and you can double-click it to open your imported board.
    `
  },
  BOARD_EXPORT: {
    title: "Board Export Started",
    message: `
      Your board export has started and is being processed in the background.<br/><br/>
      <b>What happens next?</b><br/>
      - You can continue working while we prepare your board export.<br/>
      - A notification banner will appear at the top of the screen.<br/>
      - When the export is complete, the banner will update and you can double-click it to download your exported board. <br/>
      - When the export is complete, your file will be automatically downloaded.
    `
  },
  BULK_ENTITY_COPY: {
    title: "Bulk Copy Started",
    message: `
      Your bulk copy request has started and is being processed in the background.<br/><br/>
      <b>What happens next?</b><br/>
      - You can continue working while we copy your records.<br/>
      - A notification banner will appear at the top of the screen.<br/>
      - When the copy is complete, the banner will update to confirm.
    `
  },
  MARKETING_MANIFEST_GENERATION: {
    title: "Manifest Generation Started",
    message: `
      Your marketing manifest is being generated in the background.<br/><br/>
      <b>What happens next?</b><br/>
      - You can continue working while we prepare your manifest.<br/>
      - A notification banner will appear at the top of the screen.<br/>
      - When generation is complete, the banner will update and your read-only manifest will refresh automatically.
    `
  },
  MARKETING_TAGS_GENERATION: {
    title: "Tags Generation Started",
    message: `
      Your marketing tags are being generated in the background.<br/><br/>
      <b>What happens next?</b><br/>
      - You can continue working while we analyze your manifest.<br/>
      - A notification banner will appear at the top of the screen.<br/>
      - When generation is complete, tags are saved automatically and appear in your marketing stack.
    `
  },
  MARKETING_WORK_FILE_GENERATION: {
    title: "Work File Generation Started",
    message: `
      Your marketing work file is being generated in the background.<br/><br/>
      <b>What happens next?</b><br/>
      - You can continue working while we prepare your work file.<br/>
      - A notification banner will appear at the top of the screen.<br/>
      - When generation is complete, the banner will update and you can double-click it to view your work files.
    `
  },
  MARKETING_PAGE_GENERATION: {
    title: "Marketing Page Publishing Started",
    message: `
      Your marketing page is being generated and published in the background.<br/><br/>
      <b>What happens next?</b><br/>
      - You can keep working—publishing continues in the background.<br/>
      - A notification banner will appear at the top of the screen.<br/>
      - When publishing finishes, the banner updates; double-click it to open <b>Pages</b> with your new page highlighted.<br/>
      - Open <b>Pages</b> anytime to see every published marketing page after they sync.
    `
  },
  SITE_PUBLISH: {
    title: "Site Publishing Started",
    message: `
      Your marketing site is being built and published in the background.<br/><br/>
      <b>What happens next?</b><br/>
      - You can keep working while the site is published.<br/>
      - A notification banner will appear at the top of the screen.<br/>
      - When publishing finishes, double-click the banner to open <b>Site</b> and view your live site.<br/>
      - Open <b>Site</b> anytime to push updates after editing SEO or included pages.
    `
  },
};

export default ASYNC_TASK_MESSAGES;
